import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getQuizById } from '../data/quizRegistry';

function Header() {
  const navigate = useNavigate();
  const { quizId } = useParams<{ quizId: string }>();

  const quiz = quizId ? getQuizById(quizId) : null;
  const title = quiz ? quiz.title : '건강 테스트 모음';
  const bgColor = quiz ? quiz.headerColor : '#FFD6FF';

  const handleClick = () => {
    navigate('/');
  };

  return (
    <header style={{ backgroundColor: bgColor }}>
      <h1 onClick={handleClick} style={{ cursor: 'pointer' }}>
        {title}
      </h1>
    </header>
  );
}

export default Header;
